// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bar":"app-components-kit-waveform-bars--bar","disabledBar":"app-components-kit-waveform-bars--disabledBar app-components-kit-waveform-bars--bar"};